import { AbstractService } from '@uniqoders/sdk';

export default class TeamMemberService extends AbstractService {
  public listCmsTeamMembers(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/team-members', { agency }),
      params,
    });
  }

  public getCmsTeamMember(agency: string, cmsTeamMemberId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/team-members/{cmsTeamMemberId}', { agency, cmsTeamMemberId }),
      params,
      headers,
    });
  }

  public createCmsTeamMember(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/team-members', { agency }),
      data,
    });
  }

  public updateCmsTeamMember(agency: string, cmsTeamMemberId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/team-members/{cmsTeamMemberId}', { agency, cmsTeamMemberId }),
      data,
    });
  }

  public deleteCmsTeamMember(agency: string, cmsTeamMemberId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/team-members/{cmsTeamMemberId}', { agency, cmsTeamMemberId }),
    });
  }

  public publishCmsTeamMember(
    agency: string,
    cmsTeamMemberId: number,
    data: { is_public: boolean },
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/team-members/{cmsTeamMemberId}/publish', { agency, cmsTeamMemberId }),
      data,
    });
  }

  public uploadFeaturedImage(agency: string, cmsTeamMemberId: number, data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/team-members/{cmsTeamMemberId}/upload-featured', {
        agency,
        cmsTeamMemberId,
      }),
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
